import { EmptyState } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import { COMPANY_ANALYSIS_TECHNOLOGIES } from "app/pages/sales-intelligence/constants/routes";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";
import CardFooter from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardFooter/CardFooter";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";

import TechnologiesCard from "./TechnologiesCard";

const TechnologiesCardWithErrorBoundary = () => (
    <ErrorBoundaryWithLogging
        fallback={
            <Card
                dataAutomation="technologies-card"
                renderContent={() => (
                    <Box padding="24px">
                        <EmptyState
                            title={translate("si.company-analysis.company-data.card.empty.header")}
                            subtitle={translate("si.company-analysis.company-data.card.empty.text")}
                        />
                    </Box>
                )}
                width="50%"
                header={
                    <CardHeader
                        title={translate("si.company-analysis.technologies.card.header")}
                        infoTooltip={translate("si.company-analysis.technologies.card.header.info-tooltip")}
                    />
                }
                footer={<CardFooter stateId={COMPANY_ANALYSIS_TECHNOLOGIES} />}
            />
        }
    >
        <TechnologiesCard />
    </ErrorBoundaryWithLogging>
);

export default TechnologiesCardWithErrorBoundary;
